import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from '@components/automations/Automation.module.css';
import DateAndTimeStamp from '@components/dates/DateAndTimeStamp';
import Nbsp from '@components/Nbsp';
import Icon from '@components/text/Icon';
import BodyCopy from '@components/typography/BodyCopy';
import Heading3 from '@components/typography/Heading3';
import {
  AutomationApplicationFragment as AutomationApplicationType,
  AutomationFragment as AutomationType
} from '@typing/Generated';
import { automationConditionBlockDescription } from '@utils/automationUtils';

type AutomationConditionBlock = Extract<AutomationType['blocks'][number], { __typename: 'AutomationConditionBlock' }>;
type AutomationBlockApplication = AutomationApplicationType['automationBlockApplications'][number];

type Props = {
  automationApplication: AutomationApplicationType;
  block: AutomationConditionBlock;
  blockApplication: AutomationBlockApplication;
};

const AutomationConditionBlockApplication = ({ block, blockApplication }: Props) => {
  const intl = useIntl();
  const description = useMemo(() => automationConditionBlockDescription(block, intl), [block, intl]);

  return (
    <div className={styles.blockApplication}>
      <Heading3>
        <Icon icon="questionCircle" spacingEnd />
        <FormattedMessage id="models.automationBlockApplication.names.condition" />
      </Heading3>
      <div className={styles.blockApplicationDescription}>
        <BodyCopy>{description}</BodyCopy>
      </div>
      <div className={styles.blockApplicationDescription}>
        <BodyCopy>
          <FormattedMessage
            id={
              blockApplication.conditionResult
                ? 'models.automationBlockApplication.conditionEvaluationTrue'
                : 'models.automationBlockApplication.conditionEvaluationFalse'
            }
          />
        </BodyCopy>
      </div>
      <div className={styles.blockApplicationTiming}>
        <BodyCopy>
          <FormattedMessage id="models.automationBlockApplication.runTime" />
          <Nbsp />
          <DateAndTimeStamp value={blockApplication.createdAt} />
        </BodyCopy>
      </div>
    </div>
  );
};

export default AutomationConditionBlockApplication;
